import { render, staticRenderFns } from "./taxPersonStatistic.vue?vue&type=template&id=877a3522&scoped=true"
import script from "./taxPersonStatistic.vue?vue&type=script&lang=js"
export * from "./taxPersonStatistic.vue?vue&type=script&lang=js"
import style0 from "./taxPersonStatistic.vue?vue&type=style&index=0&id=877a3522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877a3522",
  null
  
)

export default component.exports